import { createSlice, createAction, createSelector } from "@reduxjs/toolkit";

const initialState = {
  apiError: false,
  initialLoad: false,
  loading: false,
  selectedFeature: "",
  addonFeatures: [],
  premiumAddonFeatures:[],
  selectedBackUpPlan:"",
  plansBackup: [],
  lqSession:"",
  dqBackUpPlan:"",
  selectedSpoFeature:"",
  isFromFwa:"",
};

const LandingAddonsSlice = createSlice({
  name: "LandingAddons",
  initialState,
  reducers: {
    resetAddonsState: () => {
      return initialState;
    },
    setSelectedFeature: (state, action) => {
      state["selectedFeature"] = action.payload;
    },
    setLandingAddonsPageLoading: (state, action) => {
      state["loading"] = action.payload;
    },
    setAPIError: (state, action) => {
      state["apiError"] = action.payload;
    },
    setInitialLoad: (state, action) => {
      state["initialLoad"] = action.payload;
    },
    setAddonFeatures: (state, action) => {
      state["addonFeatures"] = action.payload;
    },
    setSelectedBackUpPlan: (state, action) => {
      state["selectedBackUpPlan"] = action.payload;
    },
    setBackUpPlansDetails: (state, action) => {
      state["backUpPlansDetails"] = action.payload;
    },
    setPlansBackup: (state, action) => {
      state["plansBackup"] = action.payload;
    },
    setLqSession: (state, action) => {
      state["lqSession"] = action.payload;
    },
    setDqBackUpPlan: (state, action) => {
      state["dqBackUpPlan"] = action.payload;
    },
    setPremiumAddonFeatures: (state, action) => {
      state["premiumAddonFeatures"] = action.payload;
    },
    setAddorManageFeatures: (state, action) => {
      state["addorManageFeatures"] = action.payload;
    },
    setSelectedSpoFeature: (state, action) => {
      state["selectedSpoFeature"] = action.payload;
    },
    setIsFromFwa: (state, action) => {
      state["isFromFwa"] = action.payload;
    },
    setReserveIpResp: (state, action) => {
      state["reserveIpResp"] = action.payload;
    },
    setIpAddressDetails: (state, action) => {
      state["ipAddressDetails"] = action.payload;
    },
    setToggledFeatures: (state, action) => {
      state["toggledFeatures"] = action.payload;
    },
    setSelectedPackages: (state, action) => {
      state["selectedPackages"] = action.payload;
    },
    setAddonCartResp: (state, action) => {
      state["addonCartResp"] = action.payload;
    },
     setAddedAddonsFeatures: (state, action) => {
      const existingStateData = state.addedAddonsFeatures || [];
      const payload = Array.isArray(action.payload) ? action.payload : [action.payload];
    
      if (!payload.length) return;
    
      // Filter out existing addons of the same featureType (SFO or SPO)
      const filteredStateData = existingStateData.filter(
        (item) => !payload.some((feat) => feat.featureType === item.featureType)
      );
    
      // Add the new addons from the payload
      state.addedAddonsFeatures = [...filteredStateData, ...payload];
    },
    setAddedAddonsFeaturesNew: (state, action) => {
      state["addedAddonsFeatures"] = action.payload
    },
  },
});

export const reducer = LandingAddonsSlice.reducer;
export const updateAddonToCart = createAction(
  "LandingAddons/updateAddonToCart"
);
export const updateManageFeatureAddonToCart = createAction(
  "LandingAddons/updateManageFeatureAddonToCart"
);
export const getAddonFeatures = createAction(
  "LandingAddons/getAddonFeatures"
);
export const getAddOrManageFeatures = createAction(
  "LandingAddons/getAddOrManageFeatures"
);
export const addToCartBackUp = createAction(
  "LandingAddons/addToCartBackUp"
);
export const getBackUpPlans = createAction(
  "LandingAddons/getBackUpPlans"
);
export const reserveIp = createAction(
  "LandingAddons/reserveIp"
);
// export const updateSpoFeatures = createAction(
//   "LandingAddons/updateSpoFeatures"
// );

export const {
  resetAddonsState,
  setInitialLoad,
  setSelectedFeature,
  setLandingAddonsPageLoading,
  setAPIError,
  setAddonFeatures,
  setSelectedBackUpPlan,
  setBackUpPlansDetails,
  setPlansBackup,
  setLqSession,
  setDqBackUpPlan,
  setPremiumAddonFeatures,
  setSelectedSpoFeature,
  setIsFromFwa,
  setAddorManageFeatures,
  setReserveIpResp,
  setIpAddressDetails,
  setToggledFeatures,
  setSelectedPackages,
  setAddonCartResp,
  setAddedAddonsFeaturesNew,
  setAddedAddonsFeatures
} = LandingAddonsSlice.actions;
